import React, { useState, useEffect, useMemo } from 'react';
import { fetchZmanimActions, fetchHebrewDateActions } from '../ZmanimWidget/actions/fetchZmanimActions';
import templates from './templates';
import { DEFAULT_VISIBLE_ZMANIM } from '../../dummies/WidgetSetupWizard/steps/ZmanimVisibilityStep';

const ZMAN_DEFINITIONS = [
  { key: 'alotHaShachar',           label: '\u05E2\u05DC\u05D5\u05EA \u05D4\u05E9\u05D7\u05E8',                          group: 'morning' },
  { key: 'misheyakir',              label: '\u05DE\u05E9\u05D9\u05DB\u05D9\u05E8 \u2014 \u05D6\u05DE\u05DF \u05D8\u05DC\u05D9\u05EA/\u05EA\u05E4\u05D9\u05DC\u05D9\u05DF', group: 'morning' },
  { key: 'misheyakirMachmir',       label: '\u05DE\u05E9\u05D9\u05DB\u05D9\u05E8 \u05DE\u05D7\u05DE\u05D9\u05E8',        group: 'morning' },
  { key: 'sunrise',                 label: '\u05D4\u05E0\u05E5 \u05D4\u05D7\u05DE\u05D4',                               group: 'morning' },
  { key: 'sofZmanShmaMGA',          label: '\u05E1\u05D5\u05F4\u05D6 \u05E7\u05F4\u05E9 \u05DE\u05D2\u05F4\u05D0 (90 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
  { key: 'sofZmanShmaMGA16Point1',  label: '\u05E1\u05D5\u05F4\u05D6 \u05E7\u05F4\u05E9 \u05DE\u05D2\u05F4\u05D0 (72 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
  { key: 'sofZmanShma',             label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05E7\u05E8\u05D9\u05D0\u05EA \u05E9\u05DE\u05E2', group: 'morning' },
  { key: 'sofZmanTfillaMGA',        label: '\u05E1\u05D5\u05F4\u05D6 \u05EA\u05E4\u05D9\u05DC\u05D4 \u05DE\u05D2\u05F4\u05D0 (90 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
  { key: 'sofZmanTfillaMGA16Point1',label: '\u05E1\u05D5\u05F4\u05D6 \u05EA\u05E4\u05D9\u05DC\u05D4 \u05DE\u05D2\u05F4\u05D0 (72 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
  { key: 'sofZmanTfilla',           label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05EA\u05E4\u05D9\u05DC\u05D4',      group: 'morning' },
  { key: 'chatzot',                 label: '\u05D7\u05E6\u05D5\u05EA \u05D4\u05D9\u05D5\u05DD',                         group: 'midday' },
  { key: 'minchaGedola',            label: '\u05DE\u05E0\u05D7\u05D4 \u05D2\u05D3\u05D5\u05DC\u05D4 \u2014 \u05D2\u05E8\u05F4\u05D0', group: 'midday' },
  { key: 'minchaGedolaMGA',         label: '\u05DE\u05E0\u05D7\u05D4 \u05D2\u05D3\u05D5\u05DC\u05D4 \u2014 \u05DE\u05D2\u05F4\u05D0', group: 'midday' },
  { key: 'minchaKetana',            label: '\u05DE\u05E0\u05D7\u05D4 \u05E7\u05D8\u05E0\u05D4 \u2014 \u05D2\u05E8\u05F4\u05D0', group: 'midday' },
  { key: 'minchaKetanaMGA',         label: '\u05DE\u05E0\u05D7\u05D4 \u05E7\u05D8\u05E0\u05D4 \u2014 \u05DE\u05D2\u05F4\u05D0', group: 'midday' },
  { key: 'plagHaMincha',            label: '\u05E4\u05DC\u05D2 \u05D4\u05DE\u05E0\u05D7\u05D4',                         group: 'midday' },
  { key: 'sunset',                  label: '\u05E9\u05E7\u05D9\u05E2\u05D4',                                            group: 'evening' },
  { key: 'beinHaShmashos',          label: '\u05D1\u05D9\u05DF \u05D4\u05E9\u05DE\u05E9\u05D5\u05EA',                   group: 'evening' },
  { key: 'tzeit85deg',              label: '\u05E6\u05D0\u05EA \u05D4\u05DB\u05D5\u05DB\u05D1\u05D9\u05DD',             group: 'evening' },
  { key: 'tzeit7083deg',            label: '\u05E6\u05D0\u05EA \u05DB\u05D5\u05DB\u05D1\u05D9\u05DD (\u05E8\u05F4\u05EA 7\u00B0)', group: 'evening' },
  { key: 'tzeit42min',              label: "\u05E6\u05D0\u05EA \u05DB\u05D5\u05DB\u05D1\u05D9\u05DD 42 \u05D3\u05E7'",  group: 'evening' },
  { key: 'tzeit50min',              label: "\u05E6\u05D0\u05EA \u05DB\u05D5\u05DB\u05D1\u05D9\u05DD 50 \u05D3\u05E7'",  group: 'evening' },
  { key: 'tzeit72min',              label: "\u05E6\u05D0\u05EA \u05DB\u05D5\u05DB\u05D1\u05D9\u05DD 72 \u05D3\u05E7'",  group: 'evening' },
  { key: 'chatzotNight',            label: '\u05D7\u05E6\u05D5\u05EA \u05D4\u05DC\u05D9\u05DC\u05D4',                   group: 'evening' },
  { key: 'sofZmanAchilatChametz',    label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05D0\u05DB\u05D9\u05DC\u05EA \u05D7\u05DE\u05E5 \u2014 \u05D2\u05E8\u05F4\u05D0', group: 'morning' },
  { key: 'sofZmanBiurChametz',       label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05D1\u05D9\u05E2\u05D5\u05E8 \u05D7\u05DE\u05E5 \u2014 \u05D2\u05E8\u05F4\u05D0', group: 'morning' },
  { key: 'sofZmanAchilatChametzMGA', label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05D0\u05DB\u05D9\u05DC\u05EA \u05D7\u05DE\u05E5 \u2014 \u05DE\u05D2\u05F4\u05D0 (72 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
  { key: 'sofZmanBiurChametzMGA',    label: '\u05E1\u05D5\u05E3 \u05D6\u05DE\u05DF \u05D1\u05D9\u05E2\u05D5\u05E8 \u05D7\u05DE\u05E5 \u2014 \u05DE\u05D2\u05F4\u05D0 (72 \u05D1\u05DE\u05E2\u05F3)', group: 'morning' },
];

export { ZMAN_DEFINITIONS };

export const HalachicTimesWidget = ({
  zmanim,
  hebrewDate,
  template = 'Classic',
  title = '\u05D6\u05DE\u05E0\u05D9 \u05D4\u05D9\u05D5\u05DD \u05D4\u05D4\u05DC\u05DB\u05EA\u05D9\u05D9\u05DD',
  showTitle = true,
  showCountdown = true,
  dispatch,
  location,
  visibleZmanim = null,
}) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const ms = showCountdown ? 1000 : 30000;
    const t = setInterval(() => setNow(new Date()), ms);
    return () => clearInterval(t);
  }, [showCountdown]);

  useEffect(() => {
    if (dispatch) {
      dispatch(fetchZmanimActions(location));
      dispatch(fetchHebrewDateActions(new Date()));
    }

    const scheduleNextRefresh = () => {
      const n = new Date();
      const next = new Date(n);
      if (n.getHours() < 2 || (n.getHours() === 2 && n.getMinutes() < 5)) {
        next.setHours(2, 5, 0, 0);
      } else {
        next.setDate(next.getDate() + 1);
        next.setHours(2, 5, 0, 0);
      }
      return setTimeout(() => {
        if (dispatch) {
          dispatch(fetchZmanimActions(location));
          dispatch(fetchHebrewDateActions(new Date()));
        }
        scheduleNextRefresh();
      }, next - n);
    };

    const tid = scheduleNextRefresh();
    return () => clearTimeout(tid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location]);

  const zmanimList = useMemo(() => {
    if (!zmanim) return [];

    const activeKeys = new Set(Array.isArray(visibleZmanim) ? visibleZmanim : DEFAULT_VISIBLE_ZMANIM);
    const CHAMETZ_KEYS = new Set([
      'sofZmanAchilatChametz', 'sofZmanBiurChametz',
      'sofZmanAchilatChametzMGA', 'sofZmanBiurChametzMGA',
    ]);
    const is14Nisan = hebrewDate?.hd === 14 && hebrewDate?.hm === 1;

    return ZMAN_DEFINITIONS
      .filter(d => {
        if (!activeKeys.has(d.key)) return false;
        if (CHAMETZ_KEYS.has(d.key) && !is14Nisan) return false;
        if (!zmanim[d.key]) return false;
        return true;
      })
      .map(d => ({ key: d.key, label: d.label, time: zmanim[d.key], group: d.group }));
  }, [zmanim, visibleZmanim, hebrewDate]);

  const countdown = useMemo(() => {
    if (!showCountdown || zmanimList.length === 0) return null;
    const totalSecs = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    for (const item of zmanimList) {
      const [h, m] = item.time.split(':').map(Number);
      const zmanSecs = h * 3600 + m * 60;
      const diff = zmanSecs - totalSecs;
      if (diff > 0 && diff <= 1800) {
        const mins = Math.floor(diff / 60);
        const secs = diff % 60;
        return { label: item.label, time: item.time, remaining: `${mins}:${String(secs).padStart(2, '0')}` };
      }
    }
    return null;
  }, [showCountdown, zmanimList, now]);

  const Template = templates[template];
  if (!Template) return <div>Template not found</div>;

  return (
    <Template
      zmanimList={zmanimList}
      title={title}
      showTitle={showTitle}
      hebrewDate={hebrewDate}
      countdown={countdown}
    />
  );
};

export default HalachicTimesWidget;
